<app-data-table mainTitle="NBS"
                singleTitle="NBS"
                routerPath="/siscoserv/nbs"
                entityPath="/tbnbs"
                [entity]="tbNbs"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
